import { useState, useEffect } from 'react'
import './styles.scss'
import { IHeader } from '@/models/IHeader'
import BookmarksModal from '../BookmarkModal'
import { ILoginState } from '@/models/ILoginState'
import NotificationModal from '../NotificationModal'
import { bookmarksApiService } from '@/services/bookmarks-api.services'
import { LocalStorageHelper } from '@/utils/local-storage-helper'
import $ from 'jquery'

interface Props {
	header: IHeader,
	loginState: ILoginState,
	initials: string
}

// Define props interface
interface MobileSecondaryMenu {
  index: number
}

export default function Navbar(props: Props) {
	const { header, loginState } = props
	const [activeMenu, setActiveMenu] = useState<number>(-1)
	const [activeMobileMenu, setActiveMobileMenu] = useState(false)
	const [activeMobileMegamenu, setActiveMobileMegamenu] = useState<number | null>(null)

	console.log('initials', props.initials)


	console.log(header)
	if(header?.isLoggedIn) {
		const storedHeaderInfo = LocalStorageHelper.getItem<IHeader>('header-info');
		if(storedHeaderInfo === undefined || storedHeaderInfo === null) {
			LocalStorageHelper.setItem('header-info', header);
		}
		else if(storedHeaderInfo) {
			if(storedHeaderInfo?.memberId !== header?.memberId) {
				LocalStorageHelper.setItem('header-info', header);
			}
		}
	}

	const fetchBookmarks = async () => {
		const storedHeaderInfo = LocalStorageHelper.getItem<IHeader>('header-info');
		if(header?.memberId !== storedHeaderInfo?.memberId) {
			await bookmarksApiService.getAndStoreBookmarks(header.memberId);
		}
	}

	useEffect(() => {
		if(header?.isLoggedIn) {
			fetchBookmarks()
		}
	}, [header?.isLoggedIn])

	useEffect(() => {
		if (activeMobileMenu) {
			document.body.classList.add('overflow-hidden')
		} else {
			document.body.classList.remove('overflow-hidden')
			$(loginState.isLoggedIn ? '#btnLoginContainer': '#btnLogoutContainer').css('display', 'none')
		}
	}, [activeMobileMenu])

	useEffect(() => {
			if(loginState.isLoggedIn) loadLogoutButton()
			else loadLoginButton();
	}, [])


	const toggleMobileMegaMenu = (index: number) => {
		if (activeMobileMegamenu != index) {
			setActiveMobileMegamenu(index)
		} else {
			setActiveMobileMegamenu(null)
		}
	}

	const triggerActiveMobileMenu = () => {
		setActiveMobileMenu(true);
	}

	const loadLogoutButton = () => {
		$('#btnLogoutContainer').css('display', 'block')
		$('.login-mobile').clone().appendTo('#loginDiv');
	}

	const loadLoginButton = () => {
		$('#btnLoginContainer').css('display', 'block')
		$('.login-mobile').clone().appendTo('#loginDiv');
	}

	function MobileSecondaryMenu (props: MobileSecondaryMenu) {
		const secondaryMegamenu  = header.primaryNavigation[props.index]
		return (
				<div className='w-full bg-white absolute z-10 h-80vh container px-4 top-0 right-0'>
				<div>
					<button
						className="flex items-center mb-5 font-light appearance-none text-text-color-80"
						onClick={() => toggleMobileMegaMenu(props.index)}
					>
						<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								fillRule="evenodd"
								clipRule="evenodd"
								d="M10.4717 2.86192C10.7321 3.12227 10.7321 3.54438 10.4717 3.80473L6.27647 7.99999L10.4717 12.1953C10.7321 12.4556 10.7321 12.8777 10.4717 13.1381C10.2114 13.3984 9.78927 13.3984 9.52892 13.1381L4.86225 8.47139C4.6019 8.21104 4.6019 7.78893 4.86225 7.52859L9.52892 2.86192C9.78927 2.60157 10.2114 2.60157 10.4717 2.86192Z"
								fill="#223851"
							/>
						</svg>
						<div className="text-slate-700 text-sm font-bold uppercase leading-tight">Back to menu</div>
					</button>
					<div className={`w-full h-[0px] border border-slate-400 border-opacity-40 mb-4 ${activeMobileMegamenu == props.index && secondaryMegamenu.primaryNavChildren.length > 1 ? 'block' : 'hidden'}`}></div>
					<div className="block bg-white h-full ">
						<span className="text-right text-sky-800 text-xl font-bold leading-7 mb-6 inline-block">{secondaryMegamenu.name}</span>
						<div className="rounded-3xl xl:flex h-full">
							<div className="w-full flex-col justify-start items-start gap-4 inline-flex">
								{
									secondaryMegamenu.primaryNavChildren.map((item, index) => {
										return (
											<div key={index} className="self-stretch text-slate-600 text-base font-normal leading-normal">{item.name}</div>
										)
									})
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}

	function LoggedInMenu() {
		return (
			<div className="w-full  flex-col justify-center flex">
				<button className="text-right py-3 text-sky-800 text-base font-normal leading-normal flex justify-between">
					<div className='flex'>
						<BookmarksModal isMobile={true} backToMenu={triggerActiveMobileMenu}></BookmarksModal>
					</div>
					<svg width="20" height="20" className='self-center' viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M6.91107 16.4226C6.58563 16.0972 6.58563 15.5695 6.91107 15.2441L12.1551 10L6.91107 4.75594C6.58563 4.43051 6.58563 3.90287 6.91107 3.57743C7.23651 3.25199 7.76414 3.25199 8.08958 3.57743L13.9229 9.41076C14.2484 9.7362 14.2484 10.2638 13.9229 10.5893L8.08958 16.4226C7.76414 16.748 7.23651 16.748 6.91107 16.4226Z"
							fill="#004A99"
						/>
					</svg>
				</button>

				<button className="text-right py-3 text-sky-800 text-base font-normal leading-normal flex justify-between">
					<div className='flex'>
						<NotificationModal isMobile={true} backToMenu={triggerActiveMobileMenu}></NotificationModal>
					</div>
					<svg width="20" height="20" className='self-center' viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M6.91107 16.4226C6.58563 16.0972 6.58563 15.5695 6.91107 15.2441L12.1551 10L6.91107 4.75594C6.58563 4.43051 6.58563 3.90287 6.91107 3.57743C7.23651 3.25199 7.76414 3.25199 8.08958 3.57743L13.9229 9.41076C14.2484 9.7362 14.2484 10.2638 13.9229 10.5893L8.08958 16.4226C7.76414 16.748 7.23651 16.748 6.91107 16.4226Z"
							fill="#004A99"
						/>
					</svg>
				</button>
			</div>
		)
	}

	return (
		<div className='lg:hidden block absolute inset-0 bg-white'>
			<div className="flex p-4 justify-between ml-0 lg:hidden md:ml-4">
				<a href="/" className="flex items-center">
					<div className="justify-start items-center inline-flex">
						<svg
							className="lg:hidden block"
							width="48"
							height="48"
							viewBox="0 0 48 48"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M26.1639 19.1515L16.257 19.3452C16.9307 20.2126 17.8663 20.6545 18.8756 20.8318C21.4041 21.1155 24.0936 20.619 26.6958 20.5126C26.8895 20.3544 26.9222 20.2562 27.0095 19.948C27.1323 19.6425 27.2086 19.2634 27.0832 19.1515H26.1639ZM25.0838 17.0458C25.9157 17.1167 26.6767 17.6295 27.4896 17.8422C27.7378 18.055 28.0897 18.0714 28.2861 18.3196C28.0569 19.3452 28.2152 20.8481 26.9932 21.1509C26.374 21.2027 25.9239 21.2737 25.0483 21.3091C23.5808 21.4073 22.157 21.4591 21.6987 21.5164C20.6376 21.6501 19.7402 21.6446 18.7665 21.6283C16.9962 21.3637 15.4769 19.9835 14.6258 18.426C14.6095 18.3196 14.6804 18.2323 14.7677 18.1968C16.8898 17.7359 19.1565 17.594 21.2623 17.0812C22.4843 16.9039 23.8645 16.7266 25.0838 17.0458ZM20.2367 15.9656C17.689 16.5329 15.1577 17.1685 12.6292 17.7877C13.6548 19.5389 14.8577 21.2546 16.0961 22.9021L23.9682 22.7793L28.267 22.6921C28.3543 22.392 29.1862 20.0217 29.4344 19.1188C29.5408 18.7124 29.7808 18.0086 29.5054 17.7822C29.0498 17.5204 28.4961 17.2203 28.0897 17.0076C27.3832 16.653 27.0095 16.5166 26.3194 16.1265C24.4619 15.2591 22.1433 15.4528 20.234 15.9656H20.2367ZM32.0912 18.5487C31.4556 18.1341 30.7028 18.996 30.0754 19.5034C29.9281 19.9671 29.7045 20.529 29.6336 21.0254C29.5981 21.1318 29.5626 21.3446 29.669 21.4155C29.7918 21.38 29.9963 21.3391 30.1955 21.14C31.0983 20.5045 31.7393 19.6643 32.5876 18.9906L32.5358 18.8678C32.3776 18.7615 32.1812 18.6905 32.0939 18.5487H32.0912ZM16.6443 26.3172C16.5216 26.5654 16.4316 26.8654 16.4861 27.1491L18.0791 28.8648C18.1855 29.0776 18.3628 29.2194 18.5564 29.3776C18.7337 29.3067 19.0174 29.2712 19.0338 29.023C18.3082 28.0847 17.8118 26.9691 17.0535 25.998C16.8953 26.0335 16.7343 26.1562 16.647 26.3172H16.6443ZM33.736 19.6643C33.5096 19.6152 33.245 19.6807 32.7677 20.008C31.232 20.9873 28.9244 22.9976 28.8916 23.2758C28.6052 23.8868 28.5779 24.7624 28.357 25.3434C28.3925 25.2888 28.4988 25.1142 28.5534 25.1142C30.4464 23.5049 32.233 21.841 34.126 20.1962C34.3197 19.8607 33.9978 19.7925 33.736 19.6643ZM26.925 23.5404L16.5734 23.734C16.928 24.3532 19.0911 27.8201 19.4047 27.7846C20.4849 27.6783 21.4669 27.6346 22.4979 27.5337C23.3953 27.4437 26.4122 27.4901 27.2796 26.1589C27.5632 25.4334 27.8278 24.4841 27.9151 23.5404H26.925ZM7.09197 32.8827L5.53446 32.0507C5.46354 32.4217 5.60538 32.8118 5.78268 33.1282C8.91406 34.7566 11.9472 36.6142 15.0895 38.2235C16.1506 38.7663 16.2624 38.6899 18.7719 38.4799C19.7675 38.3981 20.2421 38.3135 21.1586 38.2235C21.2377 37.9835 21.3714 37.6561 21.3878 37.3916C21.3878 37.3916 17.7436 37.7107 16.0633 37.9398L14.0285 36.7887L7.09197 32.8772V32.8827ZM5.05711 30.1059C4.95073 30.3541 5.09257 30.6542 5.17986 30.9024L15.9733 36.8651L16.4152 37.0424C18.2018 36.8296 19.9885 36.6005 21.7587 36.3878C22.0424 36.175 22.0779 35.7522 22.1842 35.4331L22.1133 35.3622C20.1685 35.5913 18.2564 35.9104 16.3279 36.1941C15.3896 35.7167 7.90482 31.5407 5.05711 30.1086V30.1059ZM6.13728 28.7421C5.90815 28.9003 5.60811 29.0257 5.46627 29.2549L16.2952 35.2339C16.8271 35.3185 17.7681 35.0976 18.5237 34.9503C18.7555 34.9039 21.2296 34.5084 22.4325 34.3311C22.8225 34.1374 22.8743 33.641 23.0162 33.2509L16.8053 34.1702L13.5839 32.5254C11.1071 31.2515 8.63038 29.9422 6.13455 28.7393L6.13728 28.7421ZM34.2515 9.52553V12.2696L39.0277 14.9236C39.115 14.6399 39.3114 14.3917 39.2759 14.0562C37.7375 12.5342 35.9863 10.9603 34.3743 9.52553H34.2515ZM31.8266 40.4193C31.1365 41.0739 30.43 41.7995 29.7208 42.3996C29.6854 42.6996 29.7727 43.0897 30.0209 43.3543C30.0918 43.3352 30.1791 43.3734 30.2336 43.3188C31.101 42.5578 32.0203 41.9741 32.8522 41.1612C32.8522 41.0548 32.8522 40.9484 32.7458 40.8966C32.4813 40.632 32.233 40.4356 31.8266 40.4193ZM37.1183 23.2021L28.4306 32.4544L23.9027 33.1254C23.7254 33.6737 22.6998 36.4696 22.3997 37.337C22.1351 38.0353 21.9933 38.5754 21.6742 39.1427L15.6924 39.6555L6.17274 34.2765C6.10182 34.2574 6.04999 34.2765 6.01453 34.3284L6.29821 35.8313L16.4534 42.9969L28.8725 43.1224L28.076 40.7684C28.147 40.4493 28.3952 40.2556 28.6434 40.0429C30.6783 37.8853 32.7649 35.8313 34.7998 33.6901C35.2962 31.9198 35.6317 30.0814 36.0927 28.2947C36.3764 28.3493 36.6219 28.472 36.8892 28.5784C36.641 30.0459 36.1445 31.4097 35.9345 32.8963C35.7217 33.5155 35.7927 34.2929 35.1217 34.683C33.0677 36.7178 31.1229 38.84 29.0716 40.8584L29.0362 41.0521C29.1071 41.2103 29.1589 41.4422 29.3199 41.494C30.1709 40.9103 30.8937 39.9556 31.6739 39.3364C32.4867 39.3364 33.0704 40.062 33.7796 40.3811C35.9209 38.8045 37.9012 37.2142 39.9551 35.4794C40.3452 33.9929 40.8934 32.5417 41.2999 31.0906C41.619 29.7622 42.0254 28.472 42.38 27.1436C40.6643 25.7634 38.8422 24.5769 37.1265 23.1994L37.1183 23.2021ZM6.34731 14.3399L5.94088 14.2171C5.76358 14.3944 5.78268 14.6427 5.55083 14.7845C5.46354 15.2809 5.12531 15.6683 5.05439 16.1647C4.62887 16.713 4.69979 17.474 4.38338 18.0741C3.79965 19.8253 3.70964 21.6665 3.42869 23.4885C3.48051 23.895 3.28685 24.3559 3.58689 24.6915C8.06302 27.2937 12.4546 29.8713 16.9116 32.4899L17.4926 32.689C20.5176 32.0344 23.6326 31.5734 26.6386 30.8669C28.7962 30.7087 29.9636 28.7093 31.1856 27.1164C32.7431 25.1006 34.1233 23.1176 35.6099 21.0664C35.5035 20.8372 35.3262 20.7118 35.1135 20.6245C32.4594 22.4466 30.2882 24.8306 27.8469 26.92C27.5851 27.19 27.2768 27.2418 27.045 27.4382C26.2676 27.8283 25.4575 27.9156 24.4619 28.0056C23.0162 28.1338 19.7512 28.4475 19.7512 28.4475C19.7512 28.4475 20.0567 28.9603 20.073 29.2603C19.7893 29.7377 19.3966 29.8631 18.8701 30.215C18.2455 30.5914 18.0382 30.9924 17.4899 30.8151C13.933 27.9483 10.3406 25.1006 6.80283 22.2174C6.92558 22.0592 7.01559 21.721 7.29927 21.7919C7.42475 21.9338 7.65387 21.8983 7.68933 22.1111C10.9626 24.7133 14.1485 27.3673 17.4381 29.8959C17.5799 29.9832 17.8281 30.0186 17.9154 29.825C17.1189 28.9221 16.287 28.1802 15.5614 27.2773C15.6323 26.5354 16.1097 25.9325 16.3743 25.2779C15.2068 23.0848 13.633 21.05 12.34 18.9088L11.579 18.1123L6.34185 14.3426L6.34731 14.3399ZM29.7208 3.95287C27.7569 4.05925 25.8284 4.25291 23.8645 4.41385C21.2623 4.64297 18.5564 4.59115 16.257 5.54584C13.3384 7.28064 10.6298 9.2964 7.85299 11.2249C7.65933 11.4022 7.65933 11.7568 7.76298 11.9859C8.61129 11.5086 9.44323 10.9412 10.3106 10.4639C12.0973 9.38369 13.903 8.34171 15.7251 7.29701C19.0883 5.08486 23.6163 5.88134 27.6505 5.3849C27.8278 5.54311 27.7051 5.82679 27.7924 6.02318C27.1732 6.18139 26.4667 6.11047 25.8475 6.21685C22.9807 6.60691 19.5302 5.96863 17.0535 7.49068C16.1615 7.848 9.32049 11.9313 7.73025 13.0279C7.83663 13.2761 8.08484 13.6116 8.3658 13.6116C9.86875 12.8342 11.3444 11.9968 12.8256 11.1512C13.9848 10.4911 16.0279 9.29367 17.7627 8.56811C18.5946 8.33899 19.4429 8.09077 20.3103 7.87801C22.8225 7.75526 25.3702 7.59433 27.8824 7.52341C27.866 7.71707 27.9342 7.94893 27.8115 8.09077L19.833 8.56811L19.7621 8.63903C19.372 8.63903 19.0911 8.88725 18.7174 8.92271C17.5308 9.29367 16.4616 9.9265 15.3732 10.5157C13.1556 11.7159 10.9135 12.8697 8.77495 14.179C8.98771 14.4981 9.25229 14.7627 9.57143 14.9754C12.2773 13.7889 14.9859 12.6405 17.6563 11.4185C18.5237 10.9221 19.4266 10.5702 20.3976 10.3575C22.9453 10.1447 25.3865 10.0574 27.9533 9.91559C28.0597 10.1283 28.1306 10.4284 28.0079 10.6412L20.6486 11.0667L19.4457 11.3858L10.1743 15.5619C10.4388 15.881 10.7062 16.1974 10.9707 16.4811C14.1376 15.6846 17.2335 14.7463 20.4003 13.9689L27.4078 13.8625L43.7193 24.2141L43.0483 21.631L40.8716 12.9433L29.8272 4.1138L29.7208 3.9556V3.95287ZM33.946 4.32111L42.9883 11.0094L46.9162 24.6314C46.9162 24.7896 46.7389 24.8797 46.7225 25.0215L42.1918 37.7789L30.4791 45.8119H16.3961L4.87709 36.9469C3.48051 32.5608 2.32943 28.0465 0.791016 23.7122L0.932855 23.1994L5.38989 10.3357L17.2253 2.05713H30.9565L33.946 4.32111Z"
								fill="#004A99"
							/>
						</svg>
						<div className="w-12 h-[0px] rotate-90 border border-slate-400 border-opacity-40"></div>
						<img src="/media/0tafuhhh/mavs-blue.svg" className="max-h-[24px] block lg:hidden" alt='mavs-logo' />
					</div>
				</a>
				<div className='flex items-center'>
					{
						loginState.isLoggedIn && (
							<a href='https://mvportal.vinnies.org.au/login' className="w-8 h-8 mr-4 bg-slate-200 rounded-[48px] flex-col justify-center items-center gap-2 lg:hidden inline-flex">
								<div className="text-sky-800 text-sm font-bold leading-tight">{props.initials}</div>
							</a>
						)
					}
					<button
						className="text-action-primary-blue-100 w-10 h-10 relative focus:outline-none"
						onClick={() => setActiveMobileMenu(!activeMobileMenu)}
					>
						<div className="block w-6 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
							<span className={`rounded block absolute h-[3px] w-6 bg-current transform duration-500 transition bg-action-primary-blue-100 ${activeMobileMenu ? 'rotate-45' : '-translate-y-[7px]'}`}></span>
							<span className={`rounded block absolute h-[3px] w-6 bg-current transform duration-500 transition bg-action-primary-blue-100 ${activeMobileMenu ? 'opacity-0' : 'false'}`}></span>
							<span className={`rounded block absolute h-[3px] w-6 bg-current transform duration-500 transition bg-action-primary-blue-100 ${activeMobileMenu ? '-rotate-45' : 'translate-y-[7px]'}`}></span>
						</div>
					</button>
				</div>
			</div>

			<div className={`w-full relative h-screen container mx-auto ${activeMobileMenu ? 'flex' : 'hidden'}`}>
				<div className={`w-full fixed top-[75px] left-0 overflow-auto ${activeMobileMenu ? 'flex' : 'hidden'} lg:hidden z-[1000] bg-white transition-transform transform ${activeMobileMegamenu != null ? '-translate-x-[100%]' : 'translate-x-0'}`} style={{ height: `${activeMobileMenu ? '3000px' : 0}` }}>
					<div className="w-full overflow-auto bg-white">
						<div className="container mx-auto px-5 pb-11 h-[110%] overflow-y-auto overflow-auto">
							<form className="flex w-full overflow-hidden border-2 rounded-lg border-action-primary-blue-40" action="/search/">
								<input type="text" className="bg-surface-10 px-3 py-3 w-full placeholder:text-[#83A0C0]" placeholder="Search" name="keyword" aria-label="Enter in keywords to search for matching content." />
								<button className="flex items-center justify-center bg-action-primary-yellow-100 w-11">
									<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M21.0312 18.8438L16.3438 14.1562C17.3984 12.5938 17.9453 10.6406 17.6719 8.53125C17.1641 4.9375 14.2344 2.04688 10.6797 1.57812C5.36719 0.914062 0.875 5.40625 1.53906 10.7188C2.00781 14.2734 4.89844 17.2031 8.49219 17.7109C10.6016 17.9844 12.5547 17.4375 14.1562 16.3828L18.8047 21.0703C19.4297 21.6562 20.4062 21.6562 21.0312 21.0703C21.6172 20.4453 21.6172 19.4688 21.0312 18.8438ZM4.58594 9.625C4.58594 6.89062 6.8125 4.625 9.58594 4.625C12.3203 4.625 14.5859 6.89062 14.5859 9.625C14.5859 12.3984 12.3203 14.625 9.58594 14.625C6.8125 14.625 4.58594 12.3984 4.58594 9.625Z" fill="#004A99"></path>
									</svg>
								</button>
							</form>
							<nav className="flex flex-col w-full mt-3">
								{/* Mobile: Primary Navigation */}
								<ul>
									<li className='md:hidden block'>
										<button className="py-4 text-lg font-bold text-action-primary-blue-100 flex items-center justify-between w-full">
											<a href="/" className='font-museo font-bold'>Home</a>
										</button>
									</li>
									{
										header.primaryNavigation.map((item, index) => {
											return (
												(item.accessAuthentication.includes('Logged in Users') && loginState.isLoggedIn || item.accessAuthentication.includes('Anonymous Users')) && (
													<li key={index}>
														<button className="py-4 text-lg font-bold text-action-primary-blue-100 flex items-center justify-between w-full">
															<a href={item.url} className='font-museo font-bold'>{item.name}</a>
															{
																item.primaryNavChildren.length > 0 && (
																	<svg
																		aria-hidden="true"
																		focusable="false"
																		data-prefix="fas"
																		data-icon="chevron-right"
																		className="svg-inline--fa fa-chevron-right w-4 h-4"
																		onClick={() => {
																			toggleMobileMegaMenu(index)
																		}}
																		role="img"
																		xmlns="http://www.w3.org/2000/svg"
																		viewBox="0 0 384 512"
																	>
																		<path fill="currentColor" d="M342.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L274.7 256 105.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"></path>
																	</svg>
																)
															}
														</button>
													</li>
												)
											)
										})
									}
								</ul>

								{/* Mobile: Top Navigation */}
								<ul className='mt-3'>
									{
										header.topNavigation.map((topNav, topNavIndex) => {
											return (
												<li
													key={topNavIndex}
													className="text-sky-800 text-base font-normal leading-normal mb-3"
												>
														<a href={topNav.url}>{topNav.name}</a>
												</li>
											)
										})
									}
								</ul>
							</nav>
							<div className="w-full h-[0px] mt-3 mb-4 border border-slate-400 border-opacity-40"></div>
								<LoggedInMenu />
							{/* </div>? */}
						</div>
					</div>
				</div>
				{
					activeMobileMegamenu != null && (
						<MobileSecondaryMenu
							index={activeMobileMegamenu}
						/>
					)
				}

				<div id="loginDiv" className="w-full fixed bottom-0 shadow-xl z-[2001] mt-3 px-6 py-4 font-museo bg-white border border-white justify-center items-center gap-3 inline-flex text-white text-base font-bold text-center uppercase leading-normal"
				>
				</div>
			</div>
		</div>
	)
}

